import React, { useEffect, useState, Fragment } from 'react';
import '../../ReassignQueuePage.scss'
import ReassignAssociateTableColumnHeader from './ReassignAssociateTableColumnHeader';
import ReassignAssociateTableRow from './ReassignAssociateTableRow';
import EmployeesQueueTablePages from '../../../offices/components/EmployeesQueueTablePages';
import officesService from '../../../offices/services/OfficesService';
import HrbTranslate from '../../../../components/language/HrbTranslate';
import Skeleton from '../../../../components/library/loaders/Skeleton';
import { jumpToTop } from '../../../../services/util/CommonUtil';

const ReassignAssociateTable = (props) => {
    const [associateList, setAssociateList] = useState(null);
    const limit = 25;
    const [sortType, setSortType] = useState("FirstName")
    const [reversed, setReversed] = useState(false)
    const [offset, setOffset] = useState(0)

    useEffect(() => {
        const handlePopState = () => {
            setOffset(0);
        };
        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    useEffect(() => {
        setAssociateList(null)
        getAssociateList()
    }, [sortType, offset, reversed, props.selectedOffice])

    const getAssociateList = async () => {
        if (props.selectedOffice) {
            var associateData = await officesService.getEmployees(props.selectedOffice, offset, sortType, reversed)
            if (associateData) {
                setAssociateList(associateData)
            }
        }
    }

    const handleSortChange = (sort, rev) => {
        if (sort !== sortType) {
            setSortType(sort)
            setOffset(0);
        }
        if (reversed !== rev) {
            setReversed(rev)
            setOffset(0);
        }
    }

    const handleSetOffset = (offset) => {
        jumpToTop()
        setOffset(offset)
    }

    return (
        <Fragment>
            <ReassignAssociateTableColumnHeader {...props} sort={sortType} onSortChanged={handleSortChange} onSetOffset={handleSetOffset} limit={limit} reversed={reversed} />
            {associateList == null &&
                [...Array(10)].map((o, i) =>
                    <div className="columns light-grey associate-row-loading" key={`loading_${i}`} >
                        <div className='column is-12'>
                            <Skeleton />
                        </div>
                    </div>
                )
            }
            {associateList && associateList.resultCount === 0 &&
                <div className='noassociates-wrapper'>
                    <div className='noassociates-header-text'><HrbTranslate text='QueuePage.Labels.NoAssociatesHeader' /></div>
                    <div className='noassociates-text'> <HrbTranslate text='QueuePage.Labels.NoAssociates' /></div>
                </div>
            }
            {associateList && associateList.resultCount > 0 &&
                associateList.items.map((t, i) =>
                    <ReassignAssociateTableRow employee={t} key={`row_${i}`} {...props} handleRowSelect={props.handleAssociateSelect} />
                )
            }
            {associateList && associateList.count > limit &&
                <div className='reassign-pagination'>
                    <EmployeesQueueTablePages queue={associateList} onSetOffset={handleSetOffset} />
                </div>
            }
        </Fragment>
    );
}

export default ReassignAssociateTable